<template>
    <div>
        <div class="tips" v-if="!isPdf">
            <el-alert v-for="e in $store.state.errors"
                      :key="e.key"
                      :title="e.message"
                      type="error"
                      :closable="false"></el-alert>
        </div>
        <div class="deptSurvey" v-loading="loading">
            <template v-if="sort == 'one' || isPdf">
                <h4>
                    一、主要职能
                    <el-button v-if="!isPdf && $store.state.userDetail.permissions.find(ele=>ele == '84fe50f013994583bbdf337d855f2ebc')" size="small" @click="formatText('mainFunc')">格式化</el-button>
                    <el-button v-if="!isPdf && $store.state.userDetail.permissions.find(ele=>ele == '84fe50f013994583bbdf337d855f2ebc')" size="small" @click="dialogVisible = true">提取数据</el-button>
                </h4>
                <div class="deptCon">
                    <reason type="textarea"
                            rows="23"
                            classname="qksm widest nullable"
                            name="mainFunc"
                            v-model:value="qksm['mainFunc']"
                            ref="mainFunc"></reason>
                </div>
            </template>
            <template v-if="sort == 'two' || isPdf">
                <h4>
                    二、{{typeText}}预算单位构成
                </h4>
            <p>
               纳入{{divname}}2022年{{typeText}}预算编制范围的{{typeText=="部门" ? "二级" : ""}}预算单位包括：
            </p>
                <table class="tablebm" v-for="(item,i) in 单位构成" v-if="isPdf">
                   <tr>
                     
                      <td width="10%" align="center">{{i+1}}</td>
                      <td width="90%">{{item.name.replace(i+1+'、',"").replace(i+1+'、',"")}}</td>
                   </tr>                    
                </table>
                <template v-else>
                    <el-table :data="单位构成" border style="width: 100%">
                        <el-table-column type="index" label="序号" width="100" align="center" />
                        <el-table-column label="单位名称" align="center">
                            <template #default="scope">
                                <el-input v-model="scope.row.name" style="width:100% !important"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="200px">
                            <template #default="scope">
                                <el-button size="mini" type="danger" round @click="delect(scope.$index, 1)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="ihide" style="margin-top:10px;">
                        <el-button type="danger" round @click="appendRow">添加行</el-button>
                        <el-button type="danger" round @click="save">保存</el-button>
                    </div>
                </template>
            </template>
            <el-dialog title="提取数据" v-model="dialogVisible" width="50%">
                <div>
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="年份">
                            <el-input v-model="formInline.year"
                                      placeholder="请输入年份,如2021"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-radio v-model="formInline.type" label="ys">预算</el-radio>
                            <el-radio v-model="formInline.type" label="js">预算</el-radio>
                        </el-form-item>
                    </el-form>
                </div>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button type="primary" @click="previousGaiKuang()">确 定</el-button>
                        <el-button @click="close()">取 消</el-button>
                    </span>
                </template>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    import { editQksm } from "@/api/index.js";
    import { previousGaiKuang } from '@/api/div.js'
    export default {
        name: "deptSurvey",
        components: {
            reason,
        },
        props: {
            qksmData: {
                type: Object,
                default: {},
            },
        },
        data() {
            return {
                loading: true,
                typeText: "",
                divname: "",
                qksm: {},
                sort: this.$route.query.sort,
                isPdf: Boolean,
                name: "deptSurvey",
                dialogVisible: false,
                formInline: {
                    id: this.$route.query.divid,
                    type: "ys",
                    year: "",
                },
                单位构成: [],
            };
        },
        watch: {
            qksmData: {
                deep: true,
                handler: function (newVal, oldV) {
                    this.qksm = newVal;
                },
            },
            单位构成: {
                handler() {
                    this.check()
                },
                deep: true
            },
            $route() {
                this.sort = this.$route.query.sort;
            },
        },
        created() {
            if (this.$parent.isPdf) {
                this.loading = false;
                this.isPdf = true;
                this.divname = this.$store.state.divData.divname
                this.typeText = this.$store.state.divData.type == 0 ? "单位" : "部门";
                this.qksm = this.qksmData;
            } else {
                this.isPdf = false;
                this.getDivList();
            }
            this.单位构成 = this.qksm["单位构成"] ? JSON.parse(this.qksm["单位构成"]) : [];
            this.addError();
            this.check()
        },
        updated: function () {
            if (!this.$parent.isPdf) {
                this.addError();
            }
        },
        methods: {
            addError() {
                let str = "";
              if (
                 this.isEmptyStr(this.qksm["mainFunc"]) &&
                 this.qksm["mainFunc"] != "[未填]"
              ) {
                 str += "主要职能";
              }
                //} else if (
                //    this.isEmptyStr(this.qksm["具体包括"]) &&
                //    this.qksm["具体包括"] != "[未填]"
                //) {
                //    str += "预算包括";
                //}
                if (!this.isEmptyStr(str) && str.split(",").length > 0) {
                    this.addOrSet("deptSurvey", str + "未填写完整");
                } else {
                    this.remove("deptSurvey");
                }
            },
            close() {
                this.formInline.type = "ys";
                this.formInline.year = "";
                this.dialogVisible = false;
            },
            async previousGaiKuang() {
                if (this.formInline.type == "" || this.formInline.year == "") {
                    this.$message.error("请填写完整");
                } else {
                    previousGaiKuang(this.formInline).then((res) => {
                        if (res.status == 0) {
                            if (res.主要职能 || res.具体包括) {
                                if (this.qksm["mainFunc"] || this.qksm["具体包括"]) {
                                    let r = confirm("是否进行覆盖?");
                                    if (r) {
                                        this.editPrevious(res)
                                    }
                                } else {
                                    this.editPrevious1(res)
                                }
                            } else {
                                this.$message.error("上年单位编码或名称对应不上");
                            }
                        } else if (res.status == -4) {
                            this.$message.error("“在" + this.formInline.year + "年系统中未找到对应单位的数据，无法提取”");
                        }
                        this.formInline.type = "ys";
                        this.formInline.year = "";
                    });
                }
                this.dialogVisible = false;
            },
            async editQksm(qk, sm) {
                let form = {
                    id: this.$route.query.divid,
                    qk: qk,
                    sm: sm,
                };
                let res = await editQksm(form);
                return res
            },
            async getDivList() {
                this.loading = true;
                let res = this.$store.state.divData;
                this.typeText = res.type == 0 ? "单位" : "部门";
                this.divname = res.divname;
                this.qksm = res.qksm;
                this.loading = false;
            },
            formatText(name) {
                var arr = this.qksm[name].split("\n");
                for (var i = 0; i < arr.length; i++) {
                    var object = arr[i];
                    arr[i] = object.replace(/^\s*/g, "") + "\n";
                    arr[i] = "    " + arr[i];
                }
                if (name) {
                    this.$refs[name].format = true;
                    this.qksm[name] = arr.join("");
                }
            },
            async editPrevious(res) {
                if (res.主要职能) {
                    this.qksm["mainFunc"] = res.主要职能;
                    await this.editQksm("mainFunc", res.主要职能);
                }
                if (res.具体包括) {
                    this.qksm["具体包括"] = res.具体包括;
                    await this.editQksm("具体包括", 具体包括);
                }
                this.dialogVisible = false;
                this.$message.success('提取成功')
            },
            async editPrevious1(res) {
                this.qksm["mainFunc"] = res.主要职能;
                await this.editQksm("mainFunc", res.主要职能);
                this.qksm["具体包括"] = res.具体包括;
                await this.editQksm("具体包括", res.具体包括);
                this.$message.success('提取成功')
            },
            check: function () {
                if (this.单位构成.length == 0 || (this.单位构成.length > 0 && this.单位构成[0].name == "")) {
                    this.addOrSet("unitsCom", "请检查本页：部门预算编制范围的二级预算单位未填。");
                } else {
                    this.remove("unitsCom")
                }
            },
            appendRow() {
                this.单位构成.push({
                    name: '',
                })
            },
            delect(index, num) {
                if (this.单位构成.length > 1) {
                    this.单位构成.splice(index, num)
                } else {
                    this.$alert('至少包含一个本级单位', '提示', {
                        confirmButtonText: '确定'
                    })
                }
            },
            async save() {
                let res = await this.editQksm("单位构成", JSON.stringify(this.单位构成));
                if (res.status == 0) {
                    this.$message.success("保存成功")
                }
            }
        },
    };
</script>
<style scoped>
    h4 .el-button {
        margin-left: 10px;
    }

    .deptSurvey h4 {
        font-size: 20px;
        line-height: 2.5em;
    }

    .deptSurvey p {
        line-height: 2.5em;
        font-family: FangSong;
        font-size: 20px;
    }
</style>